import ToolbarButton from '../components/ToolbarButton';

const TextAlign = () => (
  <>
    <ToolbarButton
      className="ql-align"
      value="" // left is default
      text={__('Align left')}
      iconName="align-left"
      data-testid="toolbar-align-left"
    />
    <ToolbarButton
      className="ql-align"
      value="center"
      text={__('Align center')}
      iconName="align-center"
      data-testid="toolbar-align-center"
    />
    <ToolbarButton
      className="ql-align"
      value="right"
      text={__('Align right')}
      iconName="align-right"
      data-testid="toolbar-align-right"
    />
    <ToolbarButton
      className="ql-align"
      value="justify"
      text={__('Justify text')}
      iconName="align-justify"
      data-testid="toolbar-align-justify"
    />
  </>
);

export default TextAlign;
